// Import React Library
import React from "react";

// Import Empty Image
import userPablo from '../assets/images/user-pablo.jpeg';
import userEva from '../assets/images/user-eva.jpeg';
import userEve from '../assets/images/user-eve.jpeg';
import userMika from '../assets/images/user-mika.jpeg';

// Import Icons
import { MdPhoneAndroid } from "react-icons/md";
import { FaWhatsappSquare } from "react-icons/fa";

// Team Component
const Team = () => {
  // Datos de los empleados
  const employees = [
    {
      id: 5,
      name: "Mikaela Echevarria",
      role: "Administración",
      avatar: userMika,
      phone: "098 250 011",
      wpp: "598098250011",
      message: "Hola Mikaela, me gustaría realizar una cotización."
    },
    {
      id: 2,
      name: "Evelyn Arbilla",
      role: "Asesor Comercial",
      avatar: userEve,
      phone: "097 660 010",
      wpp: "598097660010",
      message: "Hola Evelyn, me gustaría realizar una cotización."
    },
    {
      id: 3,
      name: "Evangelina Pereira",
      role: "Administración",
      avatar: userEva,
      phone: "098 250 025",
      wpp: "598098250025",
      message: "Hola Evangelina, me gustaría realizar una cotización."
    },
    {
      id: 4,
      name: "Pablo Cortes",
      role: "Asesor Comercial",
      avatar: userPablo,
      phone: "096 355 224",
      wpp: "598096355224",
      message: "Hola Pablo, me gustaría realizar una cotización."
    },
  ];

  return (
    <div className="projects-section px-24">
      {/* Título */}
      <h2 className="text-gray-800 text-2xl font-semibold">Equipo</h2>
      <span className="block w-16 h-1 mb-6"></span>

      {/* Grid de empleados */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {employees.map((employee) => (
          <div
            key={employee.id}
            className="flex flex-col items-center text-center p-4 bg-white rounded-lg transition max-w-xs mx-auto cursor-pointer"
          >
            <div className="w-36 h-36 rounded-full overflow-hidden border-2 border-gray-300 mb-4">
              <img
                src={employee.avatar}
                alt={employee.name}
                className="w-full h-full object-cover transition-transform duration-500 transform hover:scale-110"
              />
            </div>
            <h3 className="text-lg font-bold text-gray-800">{employee.name}</h3>
            <span className="block w-12 h-1 mb-4 mt-1"></span>
            <p className="text-sm text-gray-600">{employee.role}</p>

            {/* Teléfono: ahora es un <a href="tel:..."> para que GTM lo detecte, sin cambiar estilos */}
            <a
              href={`tel:+${employee.wpp}`}
              className="text-sm text-gray-600 flex items-center no-underline hover:text-gray-600 focus:text-gray-600"
              aria-label={`Llamar a ${employee.name}`}
              title={`Llamar a ${employee.phone}`}
            >
              <MdPhoneAndroid className="mr-1" /> {employee.phone}
            </a>

            <br/>

            <a
              href={`https://wa.me/${employee.wpp}?text=${encodeURIComponent(employee.message)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 ease-in-out hover:scale-125"
            >
              <FaWhatsappSquare size={32} color="#25D366" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

// Export Team Component
export default Team;